/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="70.08"
        height="95.58"
        viewBox="0 0 70.08 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M55.21 33.21a1.24 1.24 0 0 1 1.29 1.29v5.05l-.06 1.18-.06 1.13C55.17 57.5 50.43 62.2 35.73 63.99l-1.07.12-.55.06-.55.06c-9.8.91-16.09 4.33-19.73 10.07-3.06 4.83-4.28 11.18-4.3 20a1.25 1.25 0 0 1-2.5 0c0-9.29 1.32-16.06 4.69-21.37 4-6.33 10.83-10.11 21-11.17l1.06-.1 1-.11 1-.12.93-.12c11.4-1.53 15.5-5.06 16.79-16.44l.1-.94.08-1c0-.5.07-1 .1-1.53l.06-1.06V34.5a1.25 1.25 0 0 1 1.37-1.29Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M54.28 30.97a1.25 1.25 0 0 1 1.75-.1l.1.1 13.63 15A1.252 1.252 0 0 1 68 47.75l-.09-.1-12.71-14-13 14.25a1.26 1.26 0 0 1-1.66.17L40.5 48a1.26 1.26 0 0 1-.17-1.66l.09-.1Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M55.2 0a10.68 10.68 0 1 0 10.69 10.68A10.68 10.68 0 0 0 55.2 0Zm0 2.5a8.18 8.18 0 1 1-8.18 8.18A8.19 8.19 0 0 1 55.2 2.5ZM19.23 29.97a1.25 1.25 0 0 1 1.86 1.67l-.09.1L2.13 50.61a1.25 1.25 0 0 1-1.85-1.67l.09-.1Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M.37 29.97a1.25 1.25 0 0 1 1.66-.09l.1.09L21 48.84a1.25 1.25 0 0 1 0 1.77 1.27 1.27 0 0 1-1.67.09l-.1-.09L.37 31.74a1.25 1.25 0 0 1 0-1.77ZM63.75 74.5a1.25 1.25 0 0 1 1.77 0 1.27 1.27 0 0 1 .09 1.67l-.09.1-18.87 18.82a1.243 1.243 0 0 1-1.85-1.66l.09-.1Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M44.89 74.5a1.25 1.25 0 0 1 1.66-.09l.1.09L65.5 93.33a1.24 1.24 0 0 1 0 1.76 1.26 1.26 0 0 1-1.67.1l-.1-.1-18.84-18.86a1.25 1.25 0 0 1 0-1.73Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'CurvedArrowThroughXxoIcon';

export default Icon;
